var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurantMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09999 13.3395L10.93 10.5095L3.90999 3.49947C2.34999 5.05947 2.34999 7.58947 3.90999 9.15947L8.09999 13.3395ZM20.15 10.1495C22.06 8.23947 22.43 5.49947 20.96 4.02947C19.5 2.56947 16.76 2.92947 14.84 4.83947C13.25 6.42947 12.75 8.57947 13.46 10.1095L3.69999 19.8695L5.10999 21.2795L12 14.4095L18.88 21.2895L20.29 19.8795L13.41 12.9995L14.88 11.5295C16.41 12.2395 18.56 11.7395 20.15 10.1495Z",
    fill: "#003A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantMenu);
export default __webpack_public_path__ + "static/media/restaurant_menu.31fc3e3a381bbb28feed176e3e3d0b5d.svg";
export { ForwardRef as ReactComponent };